/* Maisie's Munch "How to" demos (18 Oct 2026). Short narrated demonstrations that play on the real pages:
   each step lights up one thing, Emma says what it is (Kokoro bf_emma, recorded free on Keep) and the words
   show along the bottom. Same design as the How to demos on the SEND Insight Dashboard and the Benham and
   Becher desks. The words and targets are in mm-howto-demos.js; the clips are mm-howto-<key>.mp3 assets.
   Tools (record, check, film): tools/howto/ in the Maisie's Munch repo.

   A demo only shows things. It never presses Add to cart, Buy with Shop or anything that sends a form, and
   when it ends it puts the order form back exactly as it was (sizes, names, favourites, holding hands).

   Open one with ?mmhowto=<id> on any page (it moves to the demo's page and waits for Play), or
   window.mmHowtoStart(id). ?mmhowtotest=1 plays fast and silent for tools/howto/howto-check.mjs,
   =2 holds each step, =film plays at real speed for tools/howto/howto-film.mjs. */
(function () {
  if (window.mmHowtoStart) return;
  var VOICE_VERSION = 'emma-2';  // emma-2, 18 Oct: British symbols (voice/render.py)
  var SOUND_KEY = 'mm-howto-sound';
  var me = document.currentScript && document.currentScript.src;
  var BASE = me ? me.replace(/mm-howto\.js(\?.*)?$/, '') : '/';  // the theme's assets folder on Shopify's CDN
  // theme.liquid passes the look and the words with Shopify's own version stamps, so a push is seen at once.
  var tag = document.currentScript;
  var fresh = '?v=' + Date.now().toString(36).slice(0, -3);  // fallback: changes about once a minute
  var CSS_URL = (tag && tag.getAttribute('data-css')) || BASE + 'mm-howto.css' + fresh;
  var DEMOS_URL = (tag && tag.getAttribute('data-demos')) || BASE + 'mm-howto-demos.js' + fresh;
  var params = new URLSearchParams(location.search);
  var TEST = params.get('mmhowtotest');  // '1' fast and silent, '2' hold each step, 'film' real speed, autoplay

  var sleep = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var shown = function (t) { return esc(t).replace(/'/g, '’'); };
  var log = function (m) { if (TEST) console.log(m); };
  var warn = function (m) { console.warn('[howto] ' + m); (window.__mmHowtoMiss = window.__mmHowtoMiss || []).push(m); };

  // The same key as lineKey() in tools/howto/demos.mjs (FNV-1a over the UTF-8 bytes of the written line).
  function lineKey(text) {
    var h = 0x811c9dc5, bytes = new TextEncoder().encode(text), i;
    for (i = 0; i < bytes.length; i++) { h ^= bytes[i]; h = Math.imul(h, 0x01000193) >>> 0; }
    return ('0000000' + h.toString(16)).slice(-8);
  }

  // ---- loading the words and the look, only when needed ----
  var loading = null;
  function load() {
    if (loading) return loading;
    if (!document.querySelector('link[data-mm-howto]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = CSS_URL; l.setAttribute('data-mm-howto', '');
      document.head.appendChild(l);
    }
    loading = window.MM_HOWTO_DEMOS ? Promise.resolve() : new Promise(function (res) {
      var s = document.createElement('script');
      s.src = DEMOS_URL;
      s.onload = s.onerror = function () { res(); };
      document.head.appendChild(s);
    });
    return loading;
  }
  function demo(id) { return (window.MM_HOWTO_DEMOS || []).filter(function (d) { return d.id === id; })[0] || null; }

  // ---- finding things on the page ----
  // "selector", "selector @@ words" (the innermost match showing those words), "a >> b" (b inside a), or a list.
  function isShown(el) {
    if (!el || !el.isConnected) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && Number(cs.opacity) > 0.05;
  }
  var norm = function (s) { return String(s || '').replace(/[‘’]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase(); };
  function findIn(root, part) {
    var bits = part.split('@@'), sel = bits[0].trim(), words = bits[1] ? norm(bits[1]) : '', all;
    try { all = Array.prototype.slice.call(root.querySelectorAll(sel)); } catch (e) { warn('not a valid selector: ' + sel); return []; }
    if (words) {
      all = all.filter(function (el) { return norm(el.textContent).indexOf(words) >= 0; });
      all = all.filter(function (el) { return !all.some(function (o) { return o !== el && el.contains(o); }); });
    }
    return all;
  }
  function find(spec) {
    var list = Array.isArray(spec) ? spec : [spec], i, j, k;
    for (i = 0; i < list.length; i++) {
      var parts = list[i].split('>>'), roots = [document];
      for (j = 0; j < parts.length; j++) {
        var next = [];
        for (k = 0; k < roots.length; k++) next = next.concat(findIn(roots[k], parts[j]));
        roots = next;
        if (!roots.length) break;
      }
      for (k = 0; k < roots.length; k++) if (isShown(roots[k])) return roots[k];
    }
    return null;
  }

  // Things a demo must never press: anything that adds to the basket, pays, or sends a form.
  function forbidden(el) {
    if (!el || !el.closest) return true;
    if (el.closest('.shopify-payment-button, shopify-accelerated-checkout, [name="add"], .product-form__submit, [type="submit"]')) return true;
    var a = el.closest('a[href]');
    return !!(a && /\/(cart|checkout|account)/.test(a.getAttribute('href')));
  }

  // The header menu "Personalised drawings" (a <details> in the theme's mega menu, on computers only).
  function headerMenu() {
    var all = document.querySelectorAll('header details, .header details'), i;
    for (i = 0; i < all.length; i++) {
      var s = all[i].querySelector('summary');
      if (s && /personalised drawings/i.test(s.textContent) && isShown(s)) return all[i];
    }
    return null;
  }

  // ---- the order form: noted at Play, put back at the end ----
  function formState() {
    if (!document.getElementById('mm-drink-form')) return null;
    var st = { radios: [], fields: {}, picks: {}, hands: [] };
    document.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (r) { st.radios.push({ name: r.name, value: r.value }); });
    document.querySelectorAll('#mm-drink-form input[id^="mm-name-"], #mm-drawing-title, #mm-owner-name').forEach(function (i) { st.fields[i.id] = i.value; });
    document.querySelectorAll('#mm-drink-form input[id^="mm-drink-value-"]').forEach(function (i) { st.picks[i.id.split('-').pop()] = i.value; });
    document.querySelectorAll('#mm-lineup .mm-hand').forEach(function (h) { st.hands.push(h.classList.contains('is-on')); });
    return st;
  }
  function setField(el, v) { el.value = v; el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true })); }
  async function restoreForm(st) {
    if (!st) return;
    var num, i;
    Object.keys(st.fields).forEach(function (id) { var el = document.getElementById(id); if (el && el.value !== st.fields[id]) setField(el, st.fields[id]); });
    for (num in st.picks) {
      var v = document.getElementById('mm-drink-value-' + num);
      if (!v || v.value === st.picks[num]) continue;
      var change = document.querySelector('.mm-change[data-num="' + num + '"]');
      if (change) change.click();
      if (st.picks[num]) {  // the customer had chosen something before watching: choose it again
        var q = document.getElementById('mm-q-' + num);
        if (q) { setField(q, st.picks[num]); await sleep(150); }
        var opt = document.querySelector('#mm-dropdown-' + num + ' .mm-option[data-name="' + st.picks[num].replace(/"/g, '\\"') + '"]');
        if (opt) opt.click();
      }
    }
    document.querySelectorAll('.mm-chips.show').forEach(function (c) { c.classList.remove('show'); });
    document.querySelectorAll('.mm-results.show').forEach(function (c) { c.classList.remove('show'); });
    var hands = document.querySelectorAll('#mm-lineup .mm-hand');
    for (i = 0; i < hands.length && i < st.hands.length; i++) {
      var h = document.querySelectorAll('#mm-lineup .mm-hand')[i];  // the line-up redraws after each tap
      if (h && h.classList.contains('is-on') !== st.hands[i]) h.click();
    }
    for (i = 0; i < st.radios.length; i++) {
      var want = Array.prototype.filter.call(document.querySelectorAll('variant-selects input[type="radio"]'), function (x) { return x.name === st.radios[i].name && x.value === st.radios[i].value; })[0];
      if (want && !want.checked) { want.click(); await sleep(TEST ? 600 : 900); }  // the theme redraws the options after each change
    }
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
  }

  // ---- the player ----
  var P = null;
  function Player(d) {
    var self = this;
    this.d = d; this.i = -1; this.run = 0; this.paused = false; this.gone = false; this.target = null; this.spec = null;
    this.audio = null; this.saved = null;
    try { this.sound = localStorage.getItem(SOUND_KEY) !== 'off'; } catch (e) { this.sound = true; }
    this.ring = document.createElement('div'); this.ring.id = 'mm-howto-ring';
    this.bar = document.createElement('div'); this.bar.id = 'mm-howto-bar';
    this.bar.setAttribute('role', 'region'); this.bar.setAttribute('aria-label', 'How to demonstration');
    document.body.appendChild(this.ring); document.body.appendChild(this.bar);
    document.body.classList.add('mm-howto-on');
    this.bar.addEventListener('click', function (e) { var b = e.target.closest('[data-howto]'); if (b && !b.disabled) self.press(b.getAttribute('data-howto'), b); });
    this.onKey = function (e) {
      if (e.key === 'Escape' && e.isTrusted) { e.preventDefault(); self.close(); }
      else if (e.key === ' ' && e.isTrusted && self.started() && !e.target.closest('input, textarea, select, button, [contenteditable="true"]')) { e.preventDefault(); self.togglePause(); }
    };
    // Safety net while a demo is open: no form can be sent and nothing goes in the basket.
    this.onSubmit = function (e) { if (!e.isTrusted || self.started()) { e.preventDefault(); e.stopImmediatePropagation(); warn(d.id + ': blocked a form being sent'); } };
    document.addEventListener('keydown', this.onKey, true);
    window.addEventListener('submit', this.onSubmit, true);
    this.follow();
    if (TEST) { this.go(0); } else this.welcome();
  }
  Player.prototype.started = function () { return this.i >= 0 && this.i < this.d.steps.length; };

  Player.prototype.press = function (a, b) {
    if (a === 'play' || a === 'again') this.go(0);
    else if (a === 'pause') this.togglePause();
    else if (a === 'next') this.go(this.i + 1);
    else if (a === 'back') this.go(Math.max(0, this.i - 1));
    else if (a === 'sound') {
      this.sound = !this.sound;
      try { localStorage.setItem(SOUND_KEY, this.sound ? 'on' : 'off'); } catch (e) { /* private browsing */ }
      if (this.audio) this.audio.muted = !this.sound;
      b.textContent = this.sound ? 'Sound on' : 'Sound off'; b.setAttribute('aria-pressed', String(this.sound));
    }
    else if (a === 'close') this.close();
    else if (a.indexOf('watch:') === 0) { var next = a.slice(6); this.close(); start(next); }
    else if (a.indexOf('go:') === 0) { this.close(); location.href = a.slice(3); }
  };

  Player.prototype.draw = function (caption, controls) {
    this.bar.innerHTML = '<div class="mm-howto-cap" aria-live="polite">' + caption + '</div><div class="mm-howto-ctl">' + controls + '</div>';
    this.lift();
  };
  // Shopify's own strip along the bottom when previewing a theme ("Hide bar", "Exit preview"): sit above it.
  // It can arrive after the bar is drawn, so follow() asks again now and then.
  Player.prototype.lift = function () {
    var pv = document.getElementById('preview-bar-iframe');
    var lift = pv && isShown(pv) ? Math.max(0, innerHeight - pv.getBoundingClientRect().top) : 0;
    document.body.style.setProperty('--mm-howto-lift', lift + 'px');
    document.body.style.setProperty('--mm-howto-h', this.bar.offsetHeight + 'px');
  };
  Player.prototype.barTop = function () { return this.bar.getBoundingClientRect().top; };
  Player.prototype.soundBtn = function () {
    return '<button type="button" data-howto="sound" aria-pressed="' + this.sound + '">' + (this.sound ? 'Sound on' : 'Sound off') + '</button>';
  };
  Player.prototype.minutes = function () {
    var secs = this.d.steps.reduce(function (n, s) { return n + 2.2 + s.say.split(/\s+/).length / 2.6; }, 0);
    return Math.max(1, Math.round(secs / 30) / 2);
  };
  Player.prototype.welcome = function () {
    var m = this.minutes();
    this.bar.classList.add('is-intro');
    this.draw('<b>' + shown(this.d.title) + '.</b> ' + shown(this.d.blurb) +
      '<small>It plays here on the real page and only shows you things: nothing goes in your basket, and anything you had filled in is put back at the end.</small>',
      '<span class="mm-howto-name">How to · about ' + m + ' minute' + (m === 1 ? '' : 's') + '</span>' +
      '<button type="button" class="mm-howto-main" data-howto="play">▶ Play</button>' + this.soundBtn() +
      '<button type="button" class="mm-howto-x" data-howto="close">Close</button>');
    var p = this.bar.querySelector('[data-howto="play"]');
    setTimeout(function () { if (p) p.focus({ preventScroll: true }); }, 50);
  };
  Player.prototype.finish = async function () {
    this.light(null, null);
    this.bar.classList.remove('is-paused');
    var id = this.run;
    try { await restoreForm(this.saved); } catch (e) { warn(this.d.id + ': could not put the form back: ' + e); }
    this.saved = null;
    if (id !== this.run || this.gone) return;
    var more = (window.MM_HOWTO_DEMOS || []).filter(function (x) { return x.id !== this.d.id; }, this)[0];
    var back = '';
    try { back = sessionStorage.getItem('mm-howto-from') || ''; } catch (e) { /* ignore */ }
    var backBtn = this.d.id === 'order' && back && back !== location.pathname ? '<button type="button" data-howto="go:' + esc(back) + '">Back to the drawing you were looking at</button>' : '';
    this.draw('<b>That’s it.</b> ' + (this.d.id === 'order' ? 'Now try it yourself: everything is just as it was before you pressed Play.' : 'Have a look around, or watch how to order one.'),
      '<span class="mm-howto-name">' + shown(this.d.title) + ' · done</span>' +
      (this.d.id === 'order' ? '<button type="button" class="mm-howto-main" data-howto="close">Start my Munch</button>' + backBtn
        : (more ? '<button type="button" class="mm-howto-main" data-howto="watch:' + esc(more.id) + '">Watch: ' + shown(more.title) + '</button>' : '')) +
      '<button type="button" data-howto="again">Play it again</button><button type="button" class="mm-howto-x" data-howto="close">Close</button>');
    log('[howto-done] ' + this.d.id);
  };
  Player.prototype.controls = function () {
    var n = this.d.steps.length;
    return '<span class="mm-howto-name">' + shown(this.d.title) + ' · ' + (this.i + 1) + ' of ' + n + '</span>' +
      '<button type="button" data-howto="back" aria-label="Back"' + (this.i === 0 ? ' disabled' : '') + '>‹ Back</button>' +
      '<button type="button" class="mm-howto-main" data-howto="pause" aria-pressed="' + this.paused + '">' + (this.paused ? '▶ Play' : 'Pause') + '</button>' +
      '<button type="button" data-howto="next" aria-label="Next">Next ›</button>' + this.soundBtn() +
      '<button type="button" class="mm-howto-x" data-howto="close">Close</button>';
  };
  Player.prototype.togglePause = function () {
    if (!this.started()) return;
    this.paused = !this.paused;
    if (this.audio) { if (this.paused) this.audio.pause(); else this.audio.play().catch(function () {}); }
    var m = this.bar.querySelector('[data-howto="pause"]');
    if (m) { m.textContent = this.paused ? '▶ Play' : 'Pause'; m.setAttribute('aria-pressed', String(this.paused)); }
    this.bar.classList.toggle('is-paused', this.paused);
  };

  // Waits this long, not counting time spent paused.
  Player.prototype.wait = async function (ms, id) {
    var left = ms;
    while (left > 0 && id === this.run) { var t = Math.min(left, 100); await sleep(t); if (!this.paused) left -= t; }
  };
  Player.prototype.waitFor = async function (spec, ms, id) {
    var left = ms;
    for (;;) {
      var el = find(spec);
      if (el || left <= 0 || id !== this.run) return el;
      await sleep(150); if (!this.paused) left -= 150;
    }
  };

  Player.prototype.act = async function (a, id) {
    log('[howto-trace] ' + this.d.id + ' action ' + JSON.stringify(a).slice(0, 90));
    var fast = TEST === '1';
    if ('menu' in a) {
      var m = headerMenu();
      if (a.menu && m) { m.setAttribute('open', ''); var s = m.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'true'); await this.wait(fast ? 50 : 300, id); }
      if (!a.menu) document.querySelectorAll('header details[open], .header details[open]').forEach(function (x) { if (!x.closest('header-drawer, menu-drawer')) { x.removeAttribute('open'); var s2 = x.querySelector('summary'); if (s2) s2.setAttribute('aria-expanded', 'false'); } });
      return;
    }
    if (a.wait) { await this.wait(fast ? 50 : a.wait, id); return; }
    var spec = a.click || (a.type && a.type[0]);
    var el = await this.waitFor(spec, 6000, id);
    if (id !== this.run) return;
    if (!el) { warn(this.d.id + ' step ' + (this.i + 1) + ': nothing to ' + JSON.stringify(a)); return; }
    if (a.click) {
      if (forbidden(el)) { warn(this.d.id + ': refused to press ' + spec); return; }
      this.light(el, spec);
      await this.bringIntoView(el, id);
      await this.wait(fast ? 30 : 450, id);
      if (id !== this.run) return;
      el.click();
      await this.wait(fast ? 250 : 500, id);
      await this.settle(id);  // some taps scroll the page themselves (moving a person up or down)
    } else if (a.type) {
      this.light(el, spec);
      await this.bringIntoView(el, id);
      el.focus({ preventScroll: true });
      setField(el, '');
      for (var c = 0; c < a.type[1].length; c++) {
        if (id !== this.run) return;
        el.value += a.type[1][c];
        el.dispatchEvent(new Event('input', { bubbles: true }));
        await this.wait(fast ? 0 : 75, id);
      }
      el.dispatchEvent(new Event('change', { bubbles: true }));
      if (!/^mm-q-/.test(el.id)) el.blur();  // keep the search box open so its list stays on screen
      await this.wait(fast ? 100 : 350, id);
    }
  };

  // The space a target can sit in: below the theme's sticky header and above the bar.
  Player.prototype.room = function () {
    var top = 12, h = document.querySelector('.shopify-section-header-sticky, sticky-header, .section-header');
    if (h) { var r = h.getBoundingClientRect(); if (r.bottom > 0 && r.top <= 0.5 && getComputedStyle(h).position !== 'static') top = Math.max(top, r.bottom + 12); }
    return { top: top, bottom: this.barTop() - 12 };
  };
  Player.prototype.bringIntoView = async function (el, id) {
    var smooth = TEST === '1' ? 'auto' : 'smooth', r = el.getBoundingClientRect();
    if (el.closest('header, .header, .mega-menu__content')) {  // the menu sits at the top of the page
      if (r.top < 0 || r.bottom > this.barTop()) { window.scrollTo({ top: 0, behavior: smooth }); await this.wait(TEST === '1' ? 30 : 650, id); }
      return;
    }
    // In a row that scrolls sideways (the photos on a phone), bring it to the middle of the row first.
    if (r.left < 0 || r.right > innerWidth) {
      var row = el.parentElement;
      while (row && row !== document.body && !(row.scrollWidth > row.clientWidth + 2 && /auto|scroll/.test(getComputedStyle(row).overflowX))) row = row.parentElement;
      if (row && row !== document.body) {
        row.scrollTo({ left: row.scrollLeft + r.left - row.getBoundingClientRect().left - (row.clientWidth - r.width) / 2, behavior: smooth });
        await this.wait(TEST === '1' ? 30 : 500, id);
        r = el.getBoundingClientRect();
      }
    }
    var rm = this.room(), space = rm.bottom - rm.top;
    if (r.top >= rm.top && r.bottom <= rm.bottom) return;
    var y = scrollY + r.top - rm.top - Math.max(0, (space - Math.min(r.height, space)) / 2);
    window.scrollTo({ top: Math.max(0, y), behavior: smooth });
    await this.wait(TEST === '1' ? 30 : 650, id);
  };

  // Waits until the page has stopped scrolling (up to 2 seconds), so two smooth scrolls never fight.
  Player.prototype.settle = async function (id) {
    var last = -1, still = 0;
    for (var n = 0; n < 20 && still < 3 && id === this.run; n++) {
      still = Math.abs(scrollY - last) < 1 ? still + 1 : 0;
      last = scrollY;
      await sleep(100);
    }
  };
  Player.prototype.light = function (el, spec) { this.target = el; this.spec = spec; this.ring.classList.toggle('on', !!el); };
  // Keeps the ring on its target while the page scrolls or the theme redraws part of the form.
  Player.prototype.follow = function () {
    var self = this;
    var tick = function () {
      if (self.gone) return;
      var el = self.target;
      if (el && !el.isConnected && self.spec) { el = self.target = find(self.spec); }
      if (el && el.isConnected) {
        var r = el.getBoundingClientRect(), p = 7;
        var top = Math.max(r.top - p, 0), bottom = Math.min(r.bottom + p, self.barTop());
        self.ring.style.top = top + 'px'; self.ring.style.left = (r.left - p) + 'px';
        self.ring.style.width = (r.width + 2 * p) + 'px'; self.ring.style.height = Math.max(0, bottom - top) + 'px';
      }
      self.ring.classList.toggle('on', !!(el && el.isConnected));
      if ((self.ticks = (self.ticks || 0) + 1) % 30 === 0) self.lift();
      self.raf = requestAnimationFrame(tick);
    };
    this.raf = requestAnimationFrame(tick);
  };

  Player.prototype.go = async function (i) {
    if (this.gone) return;
    var id = ++this.run, steps = this.d.steps;
    this.stopAudio();
    this.paused = false;
    this.bar.classList.remove('is-intro', 'is-paused');
    if (i === 0 && !this.saved) this.saved = formState();
    if (i >= steps.length) { this.i = steps.length; this.finish(); return; }
    this.i = i; this.settled = false;
    var s = steps[i];
    log('[howto-trace] ' + this.d.id + ' step ' + (i + 1) + ' at ' + Math.round(performance.now()) + ' ms');
    this.draw(shown(s.say), this.controls());
    try {
      for (var k = 0; k < (s.do || []).length; k++) { if (id !== this.run) return; await this.act(s.do[k], id); }
      if (id !== this.run) return;
      var el = s.at ? await this.waitFor(s.at, s.opt ? 1500 : 8000, id) : null;
      if (id !== this.run) return;
      if (s.at && !el) {
        if (s.opt) { this.go(i + 1); return; }
        warn(this.d.id + ' step ' + (i + 1) + ': nothing on screen matches ' + JSON.stringify(s.at));
      }
      this.light(el, s.at);
      if (el) await this.bringIntoView(el, id);
    } catch (err) { warn(this.d.id + ' step ' + (i + 1) + ': ' + err); }
    if (id !== this.run) return;
    this.settled = true;
    if (TEST === '2') return;
    // With the sound on the step lasts as long as Emma speaks; with it off, long enough to read the words.
    await Promise.all([this.wait(TEST === '1' ? 60 : (this.sound || TEST === 'film' ? 900 : 1800 + s.say.length * 52), id), this.say(s.say, id)]);
    if (id !== this.run) return;
    await this.wait(TEST === '1' ? 0 : 650, id);
    if (id === this.run) this.go(i + 1);
  };
  Player.prototype.say = function (text, id) {
    var self = this;
    if (TEST === '1' || TEST === '2') return Promise.resolve();
    var key = lineKey(text);
    if (TEST === 'film') console.log('[howto-say] ' + key + ' ' + Math.round(performance.now()));
    return new Promise(function (res) {
      var a = new Audio(BASE + 'mm-howto-' + key + '.mp3?v=' + VOICE_VERSION);
      a.muted = !self.sound;
      self.audio = a; self._res = res;
      var done = function () { if (self._res === res) self._res = null; res(); };
      a.onended = done;
      a.onerror = function () { log('[howto] no recording for ' + key); setTimeout(done, 1800 + text.length * 52); };
      var p = a.play();
      if (p && p.catch) p.catch(function () { setTimeout(done, 1800 + text.length * 52); });  // sound blocked: give time to read
    }).then(function () { if (self.audio && id === self.run) self.audio = null; });
  };
  Player.prototype.stopAudio = function () {
    if (this.audio) { this.audio.pause(); this.audio = null; }
    if (this._res) { var r = this._res; this._res = null; r(); }
  };
  Player.prototype.close = function () {
    if (this.gone) return;
    var saved = this.saved;
    this.gone = true; this.run++; this.stopAudio(); this.saved = null;
    cancelAnimationFrame(this.raf);
    document.removeEventListener('keydown', this.onKey, true);
    this.ring.remove(); this.bar.remove();
    document.body.classList.remove('mm-howto-on'); document.body.style.removeProperty('--mm-howto-h'); document.body.style.removeProperty('--mm-howto-lift');
    this.act({ menu: false }, this.run);
    var onSubmit = this.onSubmit;
    restoreForm(saved).catch(function (e) { warn('could not put the form back: ' + e); }).then(function () { window.removeEventListener('submit', onSubmit, true); });
    P = null;
    log('[howto-closed]');
  };

  // ---- starting a demo ----
  function start(id) {
    return load().then(function () {
      var d = demo(id);
      if (!d) { warn('no demo called ' + id); return; }
      if (location.pathname.replace(/\/$/, '') !== d.page.replace(/\/$/, '')) {
        try { if (location.pathname.indexOf('/products/') === 0) sessionStorage.setItem('mm-howto-from', location.pathname); else sessionStorage.removeItem('mm-howto-from'); } catch (e) { /* ignore */ }
        location.href = d.page + '?mmhowto=' + encodeURIComponent(id) + (TEST ? '&mmhowtotest=' + TEST : '');
        return;
      }
      if (P) P.close();
      var ready = d.page.indexOf('/products/') === 0 ? '#mm-summary' : 'main';
      var t0 = Date.now();
      (function wait() {
        if (find(ready) || Date.now() - t0 > 20000) P = new Player(d);
        else setTimeout(wait, 200);
      })();
    });
  }
  window.mmHowtoStart = start;
  window.__mmHowtoState = function () { return P ? { id: P.d.id, step: P.i, settled: !!P.settled, of: P.d.steps.length, misses: window.__mmHowtoMiss || [] } : { misses: window.__mmHowtoMiss || [] }; };
  window.__mmHowtoFormState = formState;

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mm-howto]');
    if (b) { e.preventDefault(); start(b.getAttribute('data-mm-howto')); }
  });
  // ---- where the demos are offered (the "Watch" links) ----
  var MINUTES = { about: '1\u00bd min', order: '3 min' };
  function launch(id, words) {
    return '<button type="button" class="mm-howto-launch" data-mm-howto="' + id + '"><span>' + words + '</span> <small>' + MINUTES[id] + '</small></button>';
  }
  function place(where, html, how) {
    if (!where || document.querySelector('[data-mm-howto-place="' + how + '"]')) return;
    var box = document.createElement('div');
    box.className = 'mm-howto-place mm-howto-place--' + how; box.setAttribute('data-mm-howto-place', how);
    box.innerHTML = html;
    where.parentNode.insertBefore(box, how === 'order' ? where : where.nextSibling);
    load();
  }
  function placeLinks() {
    var path = location.pathname.replace(/\/$/, '') || '/';
    // Homepage: beside "Find your Munch!" in the welcome card.
    if (path === '/') {
      var btn = document.querySelector('.image-with-text__text-item .button, .image-with-text__text-item a[href]');
      if (btn) place(btn, launch('about', 'Watch: what is Maisie\u2019s Munch?'), 'home');
    }
    // How it works: both demos, under the welcome paragraph.
    if (path === '/pages/how-it-works') {
      var intro = document.querySelector('main .rte p, main .page-width p');
      if (intro) place(intro, '<div class="mm-howto-box"><p class="mm-howto-box__title">Watch how it works</p>' +
        '<p class="mm-howto-box__text">Two short films that play right here on the site, with Maisie\u2019s menu and order form.</p>' +
        launch('about', 'What Maisie\u2019s Munch is all about') + launch('order', 'How to order a personalised drawing') + '</div>', 'how');
    }
    // A personalised drawing's page (the person form; not Personalities): above "Your print".
    if (path.indexOf('/products/') === 0) {
      var t0 = Date.now();
      (function wait() {
        var print = document.querySelector('.mm-step-title--print');
        var people = document.querySelector('#mm-persons-container .mm-step-title');
        if (print && people) { if (/who/i.test(people.textContent)) place(print, launch('order', 'Watch how to order'), 'order'); }
        else if (Date.now() - t0 < 15000) setTimeout(wait, 300);
      })();
    }
  }

  function init() {
    var q = params.get('mmhowto');
    if (q) { load(); setTimeout(function () { start(q); }, 300); }
    if (!TEST) placeLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
